module.exports = __webpack_public_path__ + "static/media/3DPPA43.385156f4.jpg";